"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierRFQs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var SupplierRFQs = function () {
    var _a;
    var params = useParams();
    var supplierId = match.params.supplierId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, firestore_1.useCollection)(collectionsRef_1.RFQsRef.where("supplierId", "==", supplierId)), supplierRFQsSnapshot = _b[0], supplierRFQsLoading = _b[1];
    if (supplierRFQsLoading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var dataSource = ((_a = supplierRFQsSnapshot === null || supplierRFQsSnapshot === void 0 ? void 0 : supplierRFQsSnapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (s) {
        var _a, _b;
        var data = s.data();
        return __assign(__assign({}, data), { id: s.id, RFQNumber: data.RFQNo, projectName: (_a = projectsList_1.globalProjectsData[data.projectId]) === null || _a === void 0 ? void 0 : _a.code, overallTotal: data.overallTotal, date: (_b = data.requestedAt) === null || _b === void 0 ? void 0 : _b.toDate().toLocaleString() });
    });
    var columns = [
        {
            name: "RFQNumber",
            title: t("orders.RFQNumber"),
        },
        {
            name: "projectName",
            title: t("projects.projectCode"),
        },
        {
            name: "overallTotal",
            title: t("orders.overallTotal"),
        },
        {
            name: "date",
            title: t("orders.requestedAt"),
        },
        {
            name: "action",
            title: t("common.actions"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/purchase-orders/".concat(r.id), type: "primary", style: { margin: "0px 5px" } }, { children: t("orders.viewRFQ") })) })) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({ groups: false, filter: false }), true) })) }));
};
exports.SupplierRFQs = SupplierRFQs;
